import { render, staticRenderFns } from "./DeliverView.vue?vue&type=template&id=f3f28936&scoped=true"
import script from "./DeliverView.vue?vue&type=script&lang=js"
export * from "./DeliverView.vue?vue&type=script&lang=js"
import style0 from "./DeliverView.vue?vue&type=style&index=0&id=f3f28936&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f28936",
  null
  
)

export default component.exports